import { createRoot } from "react-dom/client";
import App from "./App";
import { restoreReturnHash } from "./utils/returnHash";

// Reapply a deep link's fragment before the first render. Components read
// `window.location.hash` in their state initializers, so this has to happen
// ahead of React or the page paints the wrong thing and then corrects itself.
restoreReturnHash();

createRoot(document.getElementById("root")).render(<App />);
